import Vue from 'vue';

const nav = {
	state: {
    mobile_nav_visible: false,
		main_nav: [
      {
        label: 'Home',
        icon: 'home',
        path: '/',
        path_name: '/',
        subnav: []
      },
      {
        label: 'Nominations',
        icon: 'clipboard-check',
        path: '/nominate/',
        path_name: '/nominate',
        subnav: []
      },
      {
        label: 'Voting',
        icon: 'check-double',
        path: '/vote/',
        path_name: '/vote',
        subnav: []
      },
      /*{
        label: 'Vote Demo',
        icon: 'check-double',
        path: '/votenow',
        path_name: '/votenow',
        subnav: []
      },
      {
        label: 'Old Vote Demo',
        icon: 'check-double',
        path: '/oldvotedemo',
        path_name: '/oldvotedemo',
        subnav: []
      }*/
    ]
	},
  get_main_nav: function() {
    return this.state.main_nav;
  },
  get_mobile_nav_visibility: function() {
    return this.state.mobile_nav_visible;
  },
  toggle_mobile_nav: function() {
    this.state.mobile_nav_visible = !this.state.mobile_nav_visible;
  },
  close_mobile_nav: function() {
    this.state.mobile_nav_visible = false;
  }
}

export default nav


// WEBPACK FOOTER //
// ./src/store/modules/mod_navigation.js